// An out-of-range move returns `items` itself, so a caller can tell nothing changed.
export const reorder = <T>(items: readonly T[], from: number, to: number): T[] => {
  if (!items[from] || to < 0 || to >= items.length) {
    return items as T[]
  }

  const next = [...items]
  const [moved] = next.splice(from, 1)
  next.splice(to, 0, moved)

  return next
}
